import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withModifiers as _withModifiers, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "chat-container" }
const _hoisted_2 = {
  class: "chat-messages",
  ref: "chatMessages"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (message, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          (message.action == 'join')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("span", null, [
                  _createElementVNode("em", null, _toDisplayString(message.data.content), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (message.action == 'left')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("span", null, [
                  _createElementVNode("em", null, _toDisplayString(message.data.content), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (message.data.action == 'chat')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("span", null, [
                  _createElementVNode("b", null, _toDisplayString(message.username) + ": ", 1),
                  _createTextVNode(" " + _toDisplayString(message.data.content), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ], 512),
    _createElementVNode("form", {
      class: "chat-input mb-0",
      onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.sendMessage && _ctx.sendMessage(...args)), ["prevent"]))
    }, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newMessage) = $event)),
        type: "text",
        id: "message",
        placeholder: "Send Message",
        disabled: _ctx.isApiCallInProgress,
        autocomplete: "off",
        onFocus: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.focusChat && _ctx.focusChat(...args))),
        onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.blurChat && _ctx.blurChat(...args))),
        onKeyup: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
      }, null, 40, _hoisted_6), [
        [_vModelText, _ctx.newMessage]
      ]),
      _createElementVNode("button", {
        class: "button m-0 bg-color text-light h-op-08",
        type: "submit",
        disabled: _ctx.isApiCallInProgress
      }, [
        (_ctx.isApiCallInProgress)
          ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
          : (_openBlock(), _createElementBlock("span", _hoisted_8, "Send"))
      ], 8, _hoisted_7)
    ], 32)
  ]))
}